import { createFeatureSelector, createSelector } from '@ngrx/store';

import { NEWSFEED_PAGE_FEATURE_KEY, NewsfeedPageState } from './newsfeed-page.reducer';

export const getState = createFeatureSelector<NewsfeedPageState>(NEWSFEED_PAGE_FEATURE_KEY);
export const getSearchTermFragment = createSelector(getState, (state: NewsfeedPageState) => state.searchTermFragment);
